<template>
    <div class="bg-white rounded shadow">
        <header class="flex items-center bg-white rounded-t border-b h-16 px-4 sm:px-6">
            <h3 class="text-base font-normal">Rents</h3>
        </header>

        <rents-list :rents="data" />

        <div
            v-if="meta.last_page > meta.page"
            class="bg-grey-bg text-grey-darker text-sm font-semibold px-4 py-2 sm:px-6"
        >
            <base-more
                :to="moreTo"
                :count="meta.count"
                :total="meta.total"
            />
        </div>
    </div>
</template>

<script>
    import RentsList from './rents-list'

    export default {
        components: {
            RentsList
        },
        props: {
            data: {
                type: Array,
                required: true
            },
            meta: {
                type: Object,
                required: true
            },
            moreTo: {
                type: Object,
                default () {
                    return {
                        name: this.$router.fix('dashboard.*rents.index')
                    }
                }
            }
        }
    }
</script>
